import styled, { css } from 'styled-components'
import fadeIn from '../../../styles/animations/fadeIn'
import { darken } from 'polished'

interface FieldProps {
  readonly error?: boolean
}

export const Container = styled.div<any>`
  ${fadeIn};
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: ${({ theme }) => darken(-0.6, theme.colors.primary)};
  padding: 0px 15px;
  height: 45px;
  border-radius: 10px;
  gap: 5px;
`
export const Field = styled.input<FieldProps>`
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: ${({ theme }) => theme.colors.primary};
  min-width: 1.15em;
  min-height: 1.15em;
  border: 0.15em solid ${({ theme }) => theme.colors.primary};
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;

  ${({ type, theme }) =>
    type === 'checkbox'
      ? css`
          border-radius: 0.15em;
          :before {
            content: '';
            width: 0.65em;
            height: 0.65em;
            transform: scale(0);
            transition: 120ms transform ease-in-out;
            box-shadow: inset 1em 1em ${theme.colors.primary};
            transform-origin: bottom left;
            clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
          }
          :checked::before {
            transform: scale(1);
          }
        `
      : css`
          border-radius: 100%;
          :before {
            content: '';
            width: 0.65em;
            height: 0.65em;
            transform: scale(0);
            transition: 120ms transform ease-in-out;
            border-radius: 100%;
            box-shadow: inset 1em 1em ${theme.colors.primary};
          }
          :checked::before {
            transform: scale(1);
          }
        `}
`

export const Label = styled.label<any>`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`
